import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalService } from '@core/services';

@Component({
  standalone: false,
  selector: 'hm-filters-panel-actions',
  templateUrl: './filters-panel-actions.component.html',
  styleUrls: ['./filters-panel-actions.component.scss'],
})
export class FiltersPanelActionsComponent {
  @Input() form!: FormGroup;
  @Input() defaultFormValue!: object;

  @Output() applyForm = new EventEmitter<void>();

  private readonly modalService = inject(ModalService);

  reset(): void {
    this.form.reset({
      ...this.defaultFormValue,
      interval: 1,
      hoursType: 1,
    });
  }

  onApply() {
    this.applyForm.emit();
  }

  close(): void {
    this.modalService.close();
  }
}
